/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Temperature_Rise_RateInputs */



/**
* | output |
* | --- |
* | "Temperature rise rate" |
*
* @param {Temperature_Rise_RateInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const temperature_rise_rate = /** @type {((inputs?: Temperature_Rise_RateInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Temperature_Rise_RateInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Temperature rise rate")
	return /** @type {LocalizedString} */ ("Vitesse de montée en température")
});